import { Box, BoxProps, ButtonNew, IconButton, Spacer } from '@jfs/ui-new'

const getDownloadDeleteView = (
  itemData: any,
  downloadReportFile: (data: any) => void,
  deleteReportFile: (data: any) => void,
  styles: BoxProps,
  rowIndex?: number,
) => {
  const onDelete = () => {
    deleteReportFile(itemData)
  }

  const onDownload = () => {
    downloadReportFile(itemData)
  }
  return (
    <Box {...styles} flexDirection={'row'} marginRight={120}>
      <ButtonNew
        testID={'downloadAction-' + rowIndex}
        textType={'body12'}
        borderWidth={1}
        borderColor={'DISABLED_GREY'}
        borderRadius={4}
        titleColor={'BLACK_21'}
        height={30}
        color={'WHITE'}
        title={'Download'}
        icon={'DOWNLOAD'}
        iconPaddingRight={'6'}
        onPress={onDownload}
        width={90}
        disabled={itemData?.status === 'In Progress' || itemData?.status === 'Failed'}
      />
      <Spacer direction={'horizontal'} size={16} />
      <Box
        borderWidth={1}
        borderColor={'DISABLED_GREY'}
        borderRadius={4}
        height={30}
        alignItems={'center'}
        justifyContent={'center'}>
        <IconButton testID={'deleteAction-' + rowIndex} onPress={onDelete} id={'DELETE'} size={14} />
      </Box>
    </Box>
  )
}

export { getDownloadDeleteView }
